import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "overlay", "onHide", "onShow", "hideCloseButton", "withPortal", "placement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { cloneElement, isValidElement, useEffect } from 'react';
import { physicalDirectionWarning } from "../../deprecationWarnings";
import styled from 'styled-components';
import { useTrigger } from "../../hooks/useTrigger";
import { deprecatedOverlayDirections, mapPhysicalToLogicalDirections } from "../../styles/mixins";
import { OverlayPortal } from "../OverlayPortal";
import { Overlay } from "../OverlayTrigger/Overlay";
var PopoverTriggerContainer = styled.div.withConfig({
  displayName: "PopoverTrigger__PopoverTriggerContainer",
  componentId: "yux5vv-0"
})(["display:inline-flex;position:relative;"]);
var TriggerContainer = styled.div.withConfig({
  displayName: "PopoverTrigger__TriggerContainer",
  componentId: "yux5vv-1"
})(["display:inline-flex;"]);

function PopoverTriggerComponent(_ref) {
  var children = _ref.children,
      overlay = _ref.overlay,
      _ref$onHide = _ref.onHide,
      onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide,
      _ref$onShow = _ref.onShow,
      onShow = _ref$onShow === void 0 ? function () {} : _ref$onShow,
      hideCloseButton = _ref.hideCloseButton,
      withPortal = _ref.withPortal,
      placement = _ref.placement,
      props = _objectWithoutProperties(_ref, _excluded);

  if (placement) {
    physicalDirectionWarning(placement);
  }

  var _useTrigger = useTrigger({
    overlay: overlay,
    onShow: onShow,
    onHide: onHide,
    withPortal: withPortal
  }),
      triggerRef = _useTrigger.triggerRef,
      overlayRef = _useTrigger.overlayRef,
      onClick = _useTrigger.onClick;
  /* if escape key is pressed, execute onHide */


  var onKeydown = function onKeydown(event) {
    if (event.keyCode === 27) {
      onHide(event);
    }
  };

  useEffect(function () {
    /* add event listener for escape key press */
    window.addEventListener('keydown', onKeydown, true);
    /* clean up */

    return function () {
      window.removeEventListener('keydown', onKeydown, true);
    };
  });
  var clonedOverlay = null;

  if (overlay && typeof overlay === 'object' && /*#__PURE__*/isValidElement(overlay)) {
    clonedOverlay = /*#__PURE__*/cloneElement(overlay, {
      onClose: hideCloseButton ? undefined : onClick
    });
  }

  return /*#__PURE__*/React.createElement(PopoverTriggerContainer, Object.assign({
    ref: triggerRef
  }, props), /*#__PURE__*/React.createElement(TriggerContainer, {
    onClick: onClick
  }, children), overlay && (withPortal && typeof triggerRef !== 'function' && triggerRef.current ? /*#__PURE__*/React.createElement(OverlayPortal, {
    overlayPosition: triggerRef.current.getBoundingClientRect(),
    closeOverlay: onHide
  }, /*#__PURE__*/React.createElement(Overlay, {
    ref: overlayRef,
    placement: mapPhysicalToLogicalDirections(placement)
  }, clonedOverlay)) : /*#__PURE__*/React.createElement(Overlay, {
    ref: overlayRef,
    placement: mapPhysicalToLogicalDirections(placement)
  }, clonedOverlay)));
} // export placement options


var popoverTriggerHelpers = _objectSpread({}, deprecatedOverlayDirections);
/**
* **PopoverTrigger** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PopoverTrigger) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-popover-popovertrigger--default) | [Encore](https://encore.spotify.net/web/components/non-visual?format=figma-figma#popovertrigger) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=613:48) |
*
* The trigger that launches a Popover, upon user interaction.
*
* @example
* () => (
*  <PopoverTrigger
*    placement={PopoverTrigger.rightBottom}
*    overlay={
*      <Popover popoverTitle="Title" arrow={Popover.leftTop}>
*        Aenean lacinia bibendum nulla sed consectetur. Cras justo.
*      </Popover>
*    }
*  >
*    <ButtonTertiary condensedAll buttonSize="lg" iconOnly={IconHelpAlt} aria-label="Help" />
*  </PopoverTrigger>
*);
*
*/


export var PopoverTrigger = Object.assign(PopoverTriggerComponent, popoverTriggerHelpers);
export default PopoverTrigger;